import {
  zohoCRMRequestManager as zohoAPI,
  connectorRequestManager as connectorAPI,
} from "../../_helpers/requestManager";

import {
  FETCH_CONNECTED_PROVIDERS_FAILED,
  FETCH_CONNECTED_PROVIDERS_START,
  FETCH_CONNECTED_PROVIDERS_SUCCESS,
} from "./actionTypes";

export const getCRMIntegrationStatus = ({ provider, apiKey, installationId }) => {
  return dispatch => {
    return zohoAPI.get(`/${provider}/integrations/status`, {
      headers: {
        "x-api-key": apiKey,
        "x-installation-id": installationId,
      },
    });
  };
};

export const disconnectCRMIntegration = ({ provider, apiKey, installationId }) => {
  return dispatch => {
    return zohoAPI.delete(`/${provider}/unauthorize`, {
      headers: {
        "x-api-key": apiKey,
        "x-installation-id": installationId,
      },
    });
  };
};

export const connectCRMIntegration = ({ provider }) => {
  return dispatch => {
    return connectorAPI.post(`/${provider}/authorize`);
  };
};

const getConnectedProvidersStart = () => {
  return { type: FETCH_CONNECTED_PROVIDERS_START };
};

const getConnectedProvidersSuccess = result => {
  return { type: FETCH_CONNECTED_PROVIDERS_SUCCESS, result };
};

const getConnectedProvidersFailed = error => {
  return { type: FETCH_CONNECTED_PROVIDERS_FAILED, error };
};

export const getConnectedProviders = () => {
  return dispatch => {
    dispatch(getConnectedProvidersStart());
    return connectorAPI
      .get("/companies/providers/connected")
      .then(r => dispatch(getConnectedProvidersSuccess(r.data.connected_accounts || [])))
      .catch(e => dispatch(getConnectedProvidersFailed(e)));
  };
};
